import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { useContext, useEffect, useState } from 'react';

import BreadCrumbs from '@/components/breadcrumbs/breadcrumb';
import { generateDynamicBCLD, getSEOProps } from '@/components/utility';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { getDealDataBySlug } from '@/services/deals';
import SetBrandsContext from '@/services/home/setBrands';
import { BRAND_NAME_EN, BRAND_NAME_FR } from '@/utils/constants';

const CardData = dynamic(() => import('../../components/offer/cardData'));
const DynamicPage = dynamic(() => import('../../components/dynamic-page'));

const SpecificOfferItem = ({ hostUrl, dealSlugRes }: any) => {
  const { locale }: any = useRouter();
  const router = useRouter();
  const [dealSlugData, setDealsSlugData] = useState<any>([]);
  const [htmlData, setHtmlData] = useState<any>();
  const pathWithoutQuery = router.asPath.split('?')[0];
  let dealSlugDataL: {
    SEO: any;
    locale: any;
    Slug: any;
    localizations: {
      data: {
        attributes: {
          locale: any;
          Slug: any;
        };
      }[];
    };
  };
  const getOfferData = () => {
    dealSlugDataL = dealSlugRes?.data[0]?.attributes;
    setHtmlData(dealSlugDataL);
    setDealsSlugData(dealSlugDataL);
    const newArray = [
      { lan: dealSlugDataL?.locale, slugValue: dealSlugDataL?.Slug },
      {
        lan: dealSlugDataL?.localizations?.data[0]?.attributes?.locale,
        slugValue: dealSlugDataL?.localizations?.data[0]?.attributes?.Slug,
      },
    ];
    if (newArray[0].lan) {
      sessionStorage.setItem('offCords', JSON.stringify(newArray));
    }
  };

  useEffect(() => {
    getOfferData();
    setHtmlData(dealSlugData);
  }, [locale, dealSlugRes, dealSlugData]);
  const headerFooterData = useContext(HeaderFooterContext);
  const { headerFooter } = headerFooterData;

  const isContext = !!headerFooter[0];

  const seoProps = getSEOProps(dealSlugRes?.data[0]?.attributes?.SEO, router);
  const getContextData = async () => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    const contextData = await SetBrandsContext(defaultBrand, locale);
    const brands = contextData?.data;
    headerFooterData.setHeaderFooterData(brands);
  };
  useEffect(() => {
    getContextData();
  }, [isContext, locale]);
  const breadCrumbUrlList = generateDynamicBCLD(router);
  if (htmlData?.Dynamic_Content?.length) {
    return (
      <div className="sv-page-content">
        <NextSeo {...seoProps} />
        <div className="my-4">
          <BreadCrumbs path={pathWithoutQuery} />
          <BreadcrumbJsonLd itemListElements={breadCrumbUrlList} />
          <DynamicPage pageData={htmlData.Dynamic_Content} />
        </div>
      </div>
    );
  }
  return (
    <div className="sv-page-content deals-detail-wrapper">
      <NextSeo {...seoProps} />
      <div className="my-4">
        <BreadCrumbs path={pathWithoutQuery} />
        <BreadcrumbJsonLd itemListElements={breadCrumbUrlList} />
        <CardData htmlData={htmlData} hostUrl={hostUrl} />
      </div>
    </div>
  );
};
export async function getServerSideProps(props: any) {
  let brand = BRAND_NAME_EN;
  const locale = props?.locale;
  if (locale === 'fr') {
    brand = BRAND_NAME_FR;
  }
  const host = props?.req?.headers?.host;

  const dealSlugResData: any = await getDealDataBySlug(
    brand,
    props?.params?.offer,
    locale
  );

  const hostUrl = `${host}/${locale}`;
  return { props: { hostUrl, dealSlugRes: dealSlugResData.data } };
}

export default SpecificOfferItem;
